import React from "react";
import ModalHeader from "@/customComponents/uiComponents/modal/ModalHeader.jsx";
import {blackSquareLogo, lock} from "@img/index.js";
import {img} from "@/utils/pluginImg.js";

/**
 * "Pay after drop-off" explainer. MIRRORS the plugin's copy — change one, change the
 * other.
 *
 * The white pill in the mint hero TITLES this modal — every surface that opens it
 * (orderDetails, paymentCards, carSelection, the perk popups, the trip pages)
 * therefore passes an empty ModalHeader title, or the name would appear twice.
 *
 * It no longer borrows the paymentCards blocks it used to (.hopn-secure-pay-head +
 * the green .hopn-no-payment-box): the design turns the assurance into a black chip
 * over a grey statement, which those classes don't describe. Only .hopn-powered-by
 * is still shared with that step.
 */
export function PayAfterDropoffContent() {
    return (
        <div className="hopn-instruction-layout hopn-pad-content">
            {/* Mint hero. Same stepped artwork as the lateness tabs — its bottom edge
                rises on the right with a concave corner no border-radius can draw, so
                it is a background IMAGE set inline here (the URL differs per portal;
                the shared SCSS can't know either path). */}
            <div
                className="hopn-pad-hero"
                style={{backgroundImage: `url(${img('lateness-hero-bg.png')})`}}
            >
                <span className="hopn-pad-hero-pill">
                    <img src={img('green-tick.svg')} alt=""/>
                    Pay After Drop-off
                </span>
                <p className="hopn-pad-hero-msg mb-0!">Book your ride and enjoy the trip — no payment
                    is taken at the time of booking.</p>
            </div>

            <div className="hopn-pad-card">
                <div className="hopn-pad-card-head">
                    <span className="hopn-pad-badge">
                        <img src={lock} alt=""/>
                        No payment today
                    </span>
                    <p className="hopn-powered-by mb-0!">
                        Powered by
                        <img src={blackSquareLogo} alt="Square"/>
                        <strong>Square</strong>
                    </p>
                </div>

                <p className="hopn-pad-panel mb-0!"><strong>Square</strong> securely holds your card and
                    charges only after your ride is completed.</p>

                <h3 className="hopn-pad-heading">How It Works?</h3>
                <p className="hopn-pad-panel mb-0!">Once you've been safely dropped off, the fare is
                    charged to your selected payment method.</p>

                <p className="hopn-pad-note mb-0!">By using hop'n, you agree to pay the quoted fare upon
                    completion of your ride.</p>
            </div>
        </div>
    );
}

export function PayAfterDropoff({setStep, closeModal, previousStep}) {
    return (
        <>
            {/* Untitled on purpose: the content's own mint-hero pill names it. */}
            <ModalHeader title="" extraClasses="" totalSteps={0} cancelButton={false} backStep={previousStep || "policiesListing"} showBackButton={true} setStep={setStep} closeModal={closeModal}/>
            <div className="modalPages-spacing pb-8">
                <PayAfterDropoffContent/>
            </div>
        </>
    );
}
export default PayAfterDropoff;
